export const BILLS_RECALCULATION_API_PATHS = {
  ACTIVE: "/recalculation/bills/active",
  COUNT: "/recalculation/bills/count",
  PREVIEW: "/recalculation/bills/preview",
  RUN: "/recalculation/bills/run",
};
